import * as React from 'react'
import LevelCard from './level-card'
import styles from './feature-grid.module.scss'

const FeatureGrid = () => (
  <div className={styles.root}>
    <div className={styles.outer}>
      <div className={styles.inner}>
        <LevelCard />
      </div>
    </div>
  </div>
)

export default FeatureGrid
